import {
  AccountMergeRequest,
  AccountMergeRequestDto,
} from './AccountMergeRequest'
import { CursorPaged, CursorPageQuery } from '../../types/definitions'
import { AccountMergeRequestFilterOption } from './AccountMergeRequestSearchViewModel'
import { collection } from '../../infra/collection'
import { MergeRequestsAPI } from '../../iam/API'

export class AccountMergeRequestStore {
  constructor(private readonly _api: MergeRequestsAPI) {}

  mergeRequests = collection<AccountMergeRequestDto, AccountMergeRequest>({
    create: () => new AccountMergeRequest(),
  })

  async list(
    query: CursorPageQuery,
    filterOption?: AccountMergeRequestFilterOption,
  ): Promise<CursorPaged<AccountMergeRequest>> {
    return this._api
      .list(query, filterOption ?? AccountMergeRequestFilterOption.Pending)
      .then((out) => CursorPaged.map(out, this.mergeRequests.set))
  }

  async link(id: string) {
    return this._api.link(id).then(this.mergeRequests.set)
  }

  async reject(id: string) {
    return this._api.reject(id).then(this.mergeRequests.set)
  }

  async ignore(id: string) {
    return this._api.ignore(id).then(this.mergeRequests.set)
  }
}
